export default __webpack_public_path__ + "media/Seguro de vida.jpg";